export default __webpack_public_path__ + "static/media/linkBlock_fake.1ef0f63b.png";